import React, { Component } from "react"
import ReactEcharts from "echarts-for-react"
import { Row, Col } from "reactstrap"

class Co2Emmission extends Component<any> {
    fuels = () => {
        let co2EmmissionArray: any[] = [
            {
                fuel: 'FO',
                co2_emission: 0,
                total: 0
            },
            {
                fuel: 'DO',
                co2_emission: 0,
                total: 0
            }
        ];

        this.props.pieChartData.map((data: any) => {
            co2EmmissionArray[1].co2_emission = co2EmmissionArray[1].co2_emission + data.co2_emission_do;
            co2EmmissionArray[0].co2_emission = co2EmmissionArray[0].co2_emission + data.co2_emission_fo;
            return '';
        })
        return {
            toolbox: {
                show: false,
            },
            tooltip: {
                trigger: "item",
                formatter: (params: any) => `${params.seriesName} <br/>${params.data.name} : ${params.percent}% (${(params.data.value).toFixed(2)} mt)`,
            },
            legend: {
                orient: "vertical",
                left: "left",
                data: co2EmmissionArray.map((data: any) => { return data.fuel.toString() }),
                // textStyle: {
                //   color: ["#858d98"],
                // },
            },
            color: ['#e72d2d', '#eb752c'],
            series: [
                {
                    name: `Co2 Emmission - Fuels`,
                    type: "pie",
                    radius: "55%",
                    center: ["50%", "60%"],
                    data: co2EmmissionArray.map((data: any) => {
                        return {
                            value: data.co2_emission,
                            name: data.fuel
                        }
                    }),
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                        },
                    },
                },
            ],
        }
    }
    operations = () => {
        let co2EmmissionArray: any[] = [
            {
                type: 'At Sea',
                co2_emission_fo: 0,
                co2_emission_do: 0,
                total: 0
            },
            {
                type: 'In Port',
                co2_emission_fo: 0,
                co2_emission_do: 0,
                total: 0
            }
        ];

        this.props.pieChartData.map((data: any) => {
            if (data.vessel_position_id === 1) {
                co2EmmissionArray[1].co2_emission_fo = co2EmmissionArray[1].co2_emission_fo + data.co2_emission_fo;
                co2EmmissionArray[1].co2_emission_do = co2EmmissionArray[1].co2_emission_do + data.co2_emission_do;
                co2EmmissionArray[1].total = co2EmmissionArray[1].co2_emission_fo + co2EmmissionArray[1].co2_emission_do;
            } else {
                co2EmmissionArray[0].co2_emission_fo = co2EmmissionArray[0].co2_emission_fo + data.co2_emission_fo;
                co2EmmissionArray[0].co2_emission_do = co2EmmissionArray[0].co2_emission_do + data.co2_emission_do;
                co2EmmissionArray[0].total = co2EmmissionArray[0].co2_emission_fo + co2EmmissionArray[0].co2_emission_do;
            }
            return '';
        })
        return {
            toolbox: {
                show: false,
            },
            tooltip: {
                trigger: "item",
                formatter: (params: any) => `${params.seriesName} <br/>${params.data.name} : ${params.percent}% (${(params.data.value).toFixed(2)} mt)`,
            },
            legend: {
                orient: "vertical",
                left: "left",
                data: co2EmmissionArray.map((data: any) => { return data.type.toString() }),
                // textStyle: {
                //   color: ["#858d98"],
                // },
            },
            color: ['#d88a24', '#e8ef33'],
            series: [
                {
                    name: `Co2 Emmission - Operations`,
                    type: "pie",
                    radius: "55%",
                    center: ["50%", "60%"],
                    data: co2EmmissionArray.map((data: any) => {
                        return {
                            value: data.total,
                            name: data.type
                        }
                    }),
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                        },
                    },
                },
            ],
        }
    }
    applicable = () => {
        let co2EmmissionArray: any[] = [
            {
                type: 'At Sea',
                co2_emission_fo: 0,
                co2_emission_do: 0,
                total: 0
            },
            {
                type: 'In Port',
                co2_emission_fo: 0,
                co2_emission_do: 0,
                total: 0
            }
        ];

        this.props.pieChartData.map((data: any) => {
            if (data.vessel_position_id === 1 && data.applicability === 'EU') {
                co2EmmissionArray[1].co2_emission_fo = co2EmmissionArray[1].co2_emission_fo + data.co2_emission_fo;
                co2EmmissionArray[1].co2_emission_do = co2EmmissionArray[1].co2_emission_do + data.co2_emission_do;
                co2EmmissionArray[1].total = co2EmmissionArray[1].co2_emission_fo + co2EmmissionArray[1].co2_emission_do;
            } else if ((data.vessel_position_id === 2 && data.applicability === 'EU')) {
                co2EmmissionArray[0].co2_emission_fo = co2EmmissionArray[0].co2_emission_fo + data.co2_emission_fo;
                co2EmmissionArray[0].co2_emission_do = co2EmmissionArray[0].co2_emission_do + data.co2_emission_do;
                co2EmmissionArray[0].total = co2EmmissionArray[0].co2_emission_fo + co2EmmissionArray[0].co2_emission_do;
            }
            return '';
        })
        return {
            toolbox: {
                show: false,
            },
            tooltip: {
                trigger: "item",
                formatter: (params: any) => `${params.seriesName} <br/>${params.data.name} : ${params.percent}% (${(params.data.value).toFixed(2)} mt)`,
            },
            legend: {
                orient: "vertical",
                left: "left",
                data: co2EmmissionArray.map((data: any) => { return data.type.toString() }),
                // textStyle: {
                //   color: ["#858d98"],
                // },
            },
            color: ['#3ab3b5', '#1a65a7'],
            series: [
                {
                    name: `Applicable CO2 Emmission`,
                    type: "pie",
                    radius: "55%",
                    center: ["50%", "60%"],
                    data: co2EmmissionArray.map((data: any) => {
                        return {
                            value: data.total,
                            name: data.type
                        }
                    }),
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: "rgba(0, 0, 0, 0.5)",
                        },
                    },
                },
            ],
        }
    }
    render() {
        return (
            <React.Fragment>
                <Row>
                    <Col lg={4} className="pos-center">
                        <h6>CO<sub>2</sub> Emmission - Fuel Types</h6>
                        <ReactEcharts style={{ height: "350px" }} option={this.fuels()} />
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}
export default Co2Emmission;
